import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectApi } from '@socialive/common';

export default createAsyncThunk('accountInfo/scheduleBroadcast', async (payload, { getState, dispatch }) => {
  const { broadcastHash, scheduledStart } = payload;
  const api = selectApi(getState());
  if (!api) throw new Error('API is required');

  await api(`/v1/broadcast/${broadcastHash}/schedule`, {
    method: 'PATCH',
    data: {
      scheduledStart,
      scheduledDurationMinutes: 120,
    },
  });
});
